import {DonationsList} from './DonationsList';

import UserIcon from '@mui/icons-material/People';

export default {
    list:DonationsList,    
    icon:UserIcon
};